 import {React, useEffect} from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import ContactformRev from "../Components/Contactform_rev";
import banner_img from "../images/banner_images/laptop/contactus.png"
import mbanner_img from "../images/banner_images/mobile/mobile_contactbanner.png"
import map from "../images/contact/map.png"
import Banner from '../Components/Banner';
// import location_map from "../images/contact/location_map.png";

function Contactpage () {

    useEffect(()=>{
        AOS.init({duration:1000});
      }, [])
    
    return(
    <>
        <div className="relative">
            <img className="relative w-full h-[500px] xl:h-[704px] object-cover lg:object-fit" src={banner_img} alt="Banner" />
            <h2 className="font-alibaba text-white text-[48px] font-bold absolute top-[35%] left-[5%] ">Contact us</h2>
        </div>

        <div className="max-w-7xl mx-auto flex flex-wrap gap-x-0 items-start px-6 my-[100px]">

            <div className="max-w-[600px] mx-auto lg:mx-0 text-center xl:text-left " data-aos="fade-up">
                <h2 className="text-[#363537] font-noto text-[32px] font-bold leading-[38.22px] ">Where you can find us:</h2>
                <p className="text-[#5F5D5E] text-[18px] font-normal leading-[27px] tracking-[0.4px] mt-10">No. 46, Kerala Club Road <br />ATT Colony, Coimbatore - 641018</p>
                <a href='tel:9025134134'><p className="text-[#5F5D5E] text-[19px] font-bold leading-[27px] tracking-[0.4px] mt-1">+91 90251 34134</p></a>
                <a href="mailto:info@landsandlands.com"><p className="text-[#5F5D5E] text-[19px] font-bold leading-[27px] tracking-[0.4px]">info@landsandlands.com</p></a>
                <a href='https://maps.app.goo.gl/SyfbzPRcaduWPCvN7' target='_blank'><img className="mt-[50px] w-[600px] h-[425px] object-cover mx-auto" src={map} alt="map" /></a>

            </div>
            
            <ContactformRev />
            

        </div>


        
        {/* <iframe className="w-full h-[543px] mt-32 cursor-pointer" src="https://api.mapbox.com/styles/v1/prithiv-map/clm4fdm6700uk01qy3i5q0bxw.html?title=false&access_token=pk.eyJ1IjoicHJpdGhpdi1tYXAiLCJhIjoiY2xtNGY5ZjJlNDV5azNkdGhkaDQ3M3MzZSJ9.3Nr6mQecTtPoap7gQ54kJg&zoomwheel=false#15.51/11.006267/76.966862" title="Streets" /> */}
        {/* <img className="w-full h-[543px] mt-32 object-cover cursor-pointer" src={location_map} alt="Location" /> */}

        {/* <div className="contact_overlay_bg  flex justify-center mt-[93px] px-6 py-20 lg:py-40" data-aos="fade-up">

            <div className="flex flex-wrap justify-center">

                <div className="max-w-[440px] h-fit bg-yellow text-center p-6 md:p-12"data-aos="fade-up">
                    <h1 className="font-noto text-[42px] font-bold leading-[44px] my-4">Work with us</h1>
                    <p className="font-alibaba text-[14px] font-[400] leading-[24px] my-8">At Lands and Lands, our passion is to help people and organisations thrive by optimising their real estate value. For over a decade we have helped individuals and organisations through our comprehensive suite of real estate and liaising services put together by an experienced team of professionals. We guide you from start to finish, both in commercial and residential real estate transactions.</p>
                    <button className="bg-white text-[14px] font-[500] uppercase tracking-[1.4px] mt-4 py-3 px-5">Contact us</button>
                </div>

                <div className="transparent_bg max-w-[452px] h-[310px] text-white text-center my-auto py-6"data-aos="fade-up">
                    <h1 className="font-noto text-[32px] font-semibold leading-[44px] tracking-[1px] my-4">Newsletter</h1>
                    <p className="font-[13px] leading-[22px]">For exclusive news and market updates,<br />sign up for our newsletter. </p>

                    <form className="mt-8">
                        <input
                            className="bg-white w-[310px] h-[44px] pl-2 md:w-[337px]"
                            type="Email"
                            placeholder="Your email"
                            name="email"
                        />
                        <input
                              className="my-6 bg-yellow px-8 py-3 uppercase font-[lato] text-[14px] text-black tracking-wider"  
                              type="submit"
                              value="Submit"
                            />
                    </form>
                </div>

            </div>

        </div> */}
        
    </>
    );
}

export default Contactpage;